/* expandingMenu functions
 * sticky header
 * PubList function
 * popUp function
 */

/* Load lazy loading
 */
var observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

/*Sticky header*/
var lastScrollTop = 0;

function popUp(URL) {
    day = new Date();
    id = day.getTime();
    window['page' + id] = window.open(URL, '" + id + "', 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=700,height=560,left = 0,top = 0');
}

function showVideo(src) {
    $('#myModal').modal('show');
    $('#myModal iframe').attr('src', src);
    $('#myModal button, .modal-backdrop').click(function () {
        $('#myModal iframe').removeAttr('src');
        $('#myModal').modal('hide');
    });
}

function stickyMenu($) {
    var $w = $(window);
    var $diff = $w.innerHeight() * 0.3;
    var $b = $('body');
    var $sticky = false;

    $w.scroll(function () {
        var st = $w.scrollTop();
        if (st <= 0 || st > lastScrollTop) {
            if ($sticky) {
                $b.removeClass("sticky-header");
                $sticky = false;
            }
            lastScrollTop = st;
        } else if (st < (lastScrollTop - $diff)) {
            $b.addClass("sticky-header");
            $sticky = true;
            lastScrollTop = st;
        }
    });
}

/** Kapott div magasság beállítása
 *
 * @param {obj} keret
 * @returns {undefined}
 */
function countCols(elemek, h) {
    colh = 0;
    colnum = 1;
    for (i = 0; i < elemek.length; i++) {
        if (colh + elemek[i] > h) {
            colh = elemek[i];
            colnum++;
        } else {
            colh = colh + elemek[i];
        }
    }
    return colnum;
}

function setHeight(keret) {
    var w = keret.innerWidth();
    var liw = keret.find(">li").outerWidth();
    var col = parseInt(w / liw);
    var htotal = 0;
    var minHeight = 0;
    var elemek = [];

    //Ha mobil, nem kell igazítás
    if (col <= 1) {
        return;
    }

    keret.find(">li").each(function () {
        elem = jQuery(this);
        elemHeight = elem.outerHeight(true);
        htotal = htotal + elemHeight;
        minHeight = Math.max(elemHeight, minHeight);
        elemek.push(elemHeight);
    });
    //ne legyen kevesebb elem, mint oszlop
    col = Math.min(col, elemek.length);

    var h = parseInt(Math.max(minHeight, htotal / col));

    //Szimuláció
    var colnum = countCols(elemek, h);
    var method;
    if (colnum > col) {
        method = "+";
    } else if (colnum <= col) {
        method = "-";
    }

    var ciklus = true;
    var counter = 0;
    while (ciklus) {
        counter++;
        colnum = countCols(elemek, h);
        switch (method) {
            case "+":
                if (colnum > col) {
                    h = h + 1;
                } else {
                    h = h + 5;
                    ciklus = false;
                }
                break;
            case "-":
                if (colnum > col) {
                    h = h + 5;
                    ciklus = false;
                } else {
                    h = h - 1;
                }
                break;
            default:
                break;
        }

        if (counter > 200) {
            ciklus = false;
        }

        if (h <= minHeight) {
            ciklus = false;
        }
    }

    keret.height(h + "px");
}

/* Menü magasság beállítása */
jQuery("#megamenu > ul > li.dropdown > a").on("click", function () {
    setTimeout(function () {
        setHeight(jQuery("#megamenu > ul > li.dropdown > ul.show"));
    }, 0);

});

function adjustMegaMenu() {
    var menus = document.getElementsByClassName('dropdown-menu show');
    var windowW = window.innerWidth;
if( typeof menus[0]!== 'undefined'){
 var menu = menus[0];
        while (menu.scrollWidth > windowW) {
            var h = menu.offsetHeight;
            h = h + h * 0.1;
            console.log(i + ':' + h);
            menu.style = 'height:' + h + 'px;';
        }

}

}
window.addEventListener("resize", adjustMegaMenu);

/*
 * sebeszet1 könyvtár oldalon használt funkció - jelenleg nem működik
 */

function PubList(doctor, doctorname) {
    var options = "toolbar=0,locationbar=0,personalbar=0,directories=0,copyhistory=0,statusbar=1,menubar=0,scrollbars=yes,noresizable,left=0,top=0,width=620,height=400";
    var urls = "http://pad.milanka.hu/orvos.php?doctor=" + doctor + "&doctorname=" + doctorname + "";
    var popup = window.open(urls, "", options);
}

// Calculate depth of menu element.
function depth(element, root) {
    var depth = 1;
    while (true) {
        if (element[0] === root[0]) {
            break;
        }
        depth++;
        element = jQuery(element).parent().parent();
    }
    return depth;
}

function setButtonClose() {
    jQuery(this).addClass('closed');
    jQuery(this).removeClass('open');
    jQuery(this).html('&#xf105;');
}

function setButtonOpen() {
    jQuery(this).addClass('open');
    jQuery(this).removeClass('closed');
    jQuery(this).html('&#xf107;');
}

function sote_owl_carousel_counter(event) {
    var element = event.target;			// DOM element, in this example .owl-carousel
    var items = event.item.count;		// Number of items
    var item = event.item.index + 1;	// Position of the current item

    jQuery('.owl-carousel-pagination span.current').text(event.item.index + 1);
}

function setKarokTopMargin() {
    var p = jQuery('.nav2karok');
    var wh = jQuery(window).height();
    var pos = p.offset();

    var topmargin = p.outerHeight(true) + pos.top + 2;
    var h = wh - topmargin;
    jQuery('#header-karok .modal-dialog').css('margin-top', topmargin).css('height', h);
}

function getKarokData() {
    // Assign handlers immediately after making the request,
    // and remember the jqxhr object for this request
    if (jQuery('#header-karok').find('#karok-nav').length > 0) {
        return true;
    }
    var jqxhr = jQuery.get(
            karok_url,
            karok_params,
            function (data) {
                jQuery('#header-karok').find('.container-fluid').html(data);
            },
            "html")
            .fail(function () {
                console.log("Header-karok ajax error");
            });
    return true;
}

jQuery(function ($) {

    $(window).on("load resize", function () {
        //Asztali vagy mobil
        if ($("#check-mobile").is(":hidden")) {
            $("body").removeClass("desktop").addClass("mobile");
        } else {
            $("body").removeClass("mobile").addClass("desktop");
        }

        if ($("body").hasClass("mobile")) {

            //Tabby első sor becsukása
            // $('.responsive-tabs__heading--active').removeClass('responsive-tabs__heading--active');
            // var first = $('.responsive-tabs__panel--active');
            // first.removeClass('responsive-tabs__panel--active');
            // first.addClass('responsive-tabs__panel--closed-accordion-only').hide();

            //Keresés tabok szélessége
            len = $('#searchoptions .nav').find('.nav-item').length;
            if (len > 0) {
                width = (100 / len).toPrecision(5) + "%";
                $('#searchoptions .nav-item').css('max-width', width);
            }
        } else {
            $('body.home #sb_instagram #sbi_images').css("width", "100%");
        }

        /* Front page - mobile posts owl carousel */
        var newscar = $('body.home .news-carousel');
        if (newscar.length && $('body').hasClass('mobile')) {
            newscar.addClass('owl-carousel');
            newscar.owlCarousel({
                items: 1,
                stagePadding: 30,
                margin: 10,
                onInitialized: sote_owl_carousel_counter, //When the plugin has initialized.
                onTranslated: sote_owl_carousel_counter //When the translation of the stage has
            });
        } else if (newscar.hasClass('owl-carousel')) {
            newscar.owlCarousel('destroy').removeClass('owl-carousel owl-loaded');
        }
          /* fokuszban szakasz - mobile posts owl carousel */
          var fokcar = $('body.home .fokusz-container-owl');
          if (fokcar.length && $('body').hasClass('mobile')) {
              fokcar.addClass('owl-carousel');
              fokcar.owlCarousel({
                  items: 1,
                  stagePadding: 30,
                  margin: 10,
                  dots: false
              });
          } else if (fokcar.hasClass('owl-carousel')) {
              fokcar.owlCarousel('destroy').removeClass('owl-carousel owl-loaded');
          }

        /* Instagram swipe */
        insta_block = $('body.home.mobile #sb_instagram');
        if (insta_block.length) {
            var insta = new Hammer($('body.home.mobile #sb_instagram')[0]);
            var offset = 340;
            var sbi_img = $('body.home.mobile #sb_instagram #sbi_images');
            var img_count = insta_block.attr("data-num");
            var padding = (sbi_img.innerWidth() - sbi_img.width()) / 2;
            sbi_img.css("width", img_count * (offset / 2 + padding));
            insta.on("swipeleft swiperight", function (e) {
                pos = sbi_img.position().left;
                w = sbi_img.width();
                if (e.type === 'swipeleft') {
                    left = (pos - offset) <= -w ? 0 : pos - offset;
                    sbi_img.css("transform", "translateX(" + left + "px)");
                } else if (e.type === 'swiperight') {
                    right = (pos + offset) >= 0 ? -w + offset : pos + offset;
                    sbi_img.css("transform", "translateX(" + right + "px)");
                }
            });
        }
    });

    /*Sticky header*/
    stickyMenu($);

    //YT playlist
    //var vbg = document.getElementById("video-bg");
    //if(vbg){
    //var BGCcontainer = vbg.parentElement;
    //BGCcontainer.style.backgroundColor = "#1C315A";
    //}
    //Popover
    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();

    //Karok gomb
    $('#header-karok').on("show.bs.modal", function () {
        getKarokData();
    });
    $(window).resize(function () {
        setKarokTopMargin();
    });

    $('#header-karok').on("shown.bs.modal", function () {
        setKarokTopMargin();
    });

    $('.nav2karok .btn').click(function () {
        $(".nav2karok").toggleClass('clicked');
    });


    //Go top
    $('#gotop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600, 'swing');
        return false;
    });

    //popup ablak nyitása popup class link esetén
    $('.popup').on('click', function (e) {
        popUp(jQuery(this).attr('href'));
        return false;
    });

    // Add toggle button to all menu elements that have children pages.
    $("#page-submenu > ul > li").each(function () {
        var root = $(this).parent();
        $("ul.children", this).each(function () {
            currentDepth = depth(this, root);
            var parentListItem = $(this).parent();

            parentListItem.prepend('<span class="btn"></span>');
            var buttons = $("span.btn", parentListItem);

            // by default all elements are open
            buttons.each(setButtonOpen);

            // closes elements by config
            if (typeof open_page['level' + currentDepth] !== 'undefined' && open_page['level' + currentDepth] === false) {
                setButtonClose.call($("span.btn", parentListItem));
                $(this).toggle();
            }


            // prevent collapsing the submenu if it contains the current page item
            var has_active_child = $('.current_page_item', this).length > 0;
            if (has_active_child === true || parentListItem.hasClass('current_page_item')) {
                if ($("span.btn", parentListItem).hasClass('closed')) {
                    setButtonOpen.call($("span.btn", parentListItem));
                    $(this).toggle();
                }
            }

            // toggle elements on button click
            var currentMenu = this;
            buttons.click(function (evt) {
                if ($(this).hasClass('open')) {
                    setButtonClose.call(this);
                } else {
                    setButtonOpen.call(this);
                }
                $(currentMenu).toggle();
            });
        });
    });

    /* multi-list */
    $('.multi-list-wrapper .multi-list-title-wrapper').on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
                $container = $this.parents('.multi-list-wrapper');

        if (!$container.hasClass('closed')) {
            $container.addClass('closed');
            $container.find('.multi-list-content').slideUp();
        } else {
            $container.removeClass('closed');
            $container.find('.multi-list-content').slideDown();
        }
    });

    /* ABC filter for multi-list */
    $('.alpha-filter .alpha-filter-letter').on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
                $alpha_filter_container = $this.parents('.alpha-filter'),
                filter_class = $this.data('filter'),
                $container = $('.multi-list-wrapper-box'),
                show_all = false;

        if ($this.hasClass('selected')) {
            $this.removeClass('selected');
            show_all = true;
        } else {
            $this.addClass('selected').siblings().removeClass('selected');
        }


        $container.find('.multi-list-wrapper').each(function () {
            if (!show_all) {
                if ($(this).hasClass(filter_class)) {
                    $(this).removeClass('hidden');
                } else {
                    $(this).addClass('hidden');
                }
            } else {
                $(this).removeClass('hidden');
            }
        });
    });

    /* Front page swipe */
    if ($('#mobile-slider .carousel-inner').length) {
        var mc = new Hammer($('#mobile-slider .carousel-inner')[0]);

        mc.on("swipeleft swiperight", function (e) {
            if (e.type === 'swipeleft') {
                $('#mobile-slider .carousel-inner .carousel-controls a.carousel-control-next').click();
            } else {
                $('#mobile-slider .carousel-inner .carousel-controls a.carousel-control-prev').click();
            }
        });
    }
    /*$('.carousel-inner').on('swipeleft', function(e){
     $('.carousel-inner .carousel-controls a.carousel-control-next.ui-link').click();
     });

     $('.carousel-inner').on('swiperight', function(e){
     $('.carousel-inner .carousel-controls a.carousel-control-prev.ui-link').click();
     });*/

    $('.munkatarsaknak-search select[name="searchorder"]').on('change', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.val() === 'date_desc') {
            window.location.href = $this.parent().find('input[name="order_desc_url"]').val();
        } else {
            window.location.href = $this.parent().find('input[name="order_asc_url"]').val();
        }
    });

    // Add smooth scrolling to anchors
    $('main .entry-content a[href^=\\#]').on('click', function (event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var topmargin = $("body").offset().top;
            var hash = this.hash;
            var jumpTo = jQuery('[name=' + hash.replace("#", "") + ']');
            if (!jumpTo.length) {
                //Search for id field
                jumpTo = jQuery(hash);
            }
            if (jumpTo.length) {
                $('html').scrollTop(jumpTo.offset().top - topmargin);
                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            }
        } // End if
    });

    //Centered images background
    $('.entry-content img.aligncenter, .entry-content figure.aligncenter img').not('.plain').wrap('<div class="pictureSemmelweis"></div>');

});

/** Adventi naptár script  */
function adventiNaptar() {

    //Carousel

    var owl1 = $(".owl-carousel");
    owl1.owlCarousel({
        center: true,
        items: 3,
        loop: false,
        margin: 10,
        dots: false,
        smartSpeed: 500,
        stagePadding: 50,
        nav: true,
        navText: [
            '<i class="fa fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Előző</span>',
            '<i class="fa fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Következő</span>',
        ],
        responsive: {
            0: {
                items: 1,
                slideBy: 1,
            },
            480: {
                items: 3,
                slideBy: 1,
            }
        }
    });

    owl1.find(".card a").click(function (e) {
        e.preventDefault();
        var item = $(this).attr('class');
        var index = item.substr(5, 100);
        owl1.trigger('to.owl.carousel', [index]);
        $(".captions .caption").hide();
        $(".captions").find("." + item).show();
        return false;
    });

    //Start
    var lastitem = owl1.find('.owl-item .card a').last().attr('class');

    if (typeof lastitem === "string") {
        var lastindex = lastitem.substr(5, 2);
        owl1.trigger('to.owl.carousel', [lastindex]);
        $(".captions .caption").hide();
        $(".captions").find("."+lastitem).show();
    }

    //Show actual page
    owl1.on('changed.owl.carousel', function (event) {
        $(".captions .caption").hide();
        $(".captions").find(".item-" + event.item.index).show();
    });

}
